import React from "react";
import s from "./LoadingSpinner.module.css";

type LoadingSpinnerProps = {
    backdrop?: boolean;
};
export default function LoadingSpinner({ backdrop }: LoadingSpinnerProps) {
    return (
        <ConditionalWrapper backdrop={backdrop}>
            <div className="loading-dots" role="status">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </ConditionalWrapper>
    );
}

const ConditionalWrapper = ({
    backdrop,
    children,
}: {
    backdrop?: boolean;
    children: React.ReactNode;
}) => {
    return backdrop ? <div className={s.Wrapper}>{children}</div> : children;
};
